import React from "react";
export const Etiqueta = (props) => {
    const estiloEtiqueta = () => {
        let anchoEtiqueta;
        let altoEtiqueta;
        if (!props.sizes) {
            let alto = props.alto ?? 1200;
            altoEtiqueta = (alto / 21.71875) - (0.28);
            anchoEtiqueta = (alto * 0.773 / 4.788) - 1;
        } else {
            altoEtiqueta = props.sizes.height;
            anchoEtiqueta = props.sizes.width;
        }
        return { width: `${anchoEtiqueta}px`, height: `${altoEtiqueta}px` };
    }

    const flor = () => {
        if (!props.data || !props.data.flor) return "Sin datos de flor";
        return props.data.flor;
    }
    const siembra = () => {
        if (!props.data || !props.data.semana) return " - ";
        return (<p><span className="text-bold text-xxs me-2">inicio</span>{props.data.semana}</p>);
    }
    const dia = () => {
        if (!props.data || !props.data.dia) return " - ";
        return (<p><span className="text-bold text-xxs me-2">Día</span>{props.data.dia}</p>);
    }
    const transplante = () => {
        if (!props.data || !props.data.transplante) return " - ";
        return
        return (<p><span className="text-bold text-xxs me-2">Transpl.</span>{props.data.transplante}</p>);
    }
    const cosecha = () => {
        if (!props.data || !props.data.cosecha) return " - ";
        return (<p><span className="text-bold text-xxs me-2">Cosecha</span>{props.data.cosecha}</p>);
    }

    const datosFecha = () => {
        let inicio = minString(props.data.semana);
        let trasplante = minString(props.data.transplante).substring(2);
        let cosecha = minString(props.data.cosecha).substring(2);
        return `${inicio}-${props.data.dia}/${trasplante}/${cosecha}`;
    }

    const minString = (word) => {
        if (typeof word != 'string' || word.length < 2) return "  ";
        return word;
    }

    return (
        <>
            <div
                className='text-center bg-white contenedor rounded m-0 pb-3'
                style={estiloEtiqueta()}>
                <div className='row justify-content-center m-0 p-0' >

                    <div className='col-sm-12 m-0 p-0 text-s text-bold' key={props.keys + 'trasp'}>{datosFecha()}</div>
                    <div className='col-sm-12 m-0 p-0 text-s text-bold' key={props.keys + 'cose'}>{flor()}</div>
                </div>
            </div>

            {props.index !== undefined && props.interno && props.externo && props.index < 3 &&
                <div className="m-0 p-0" style={{ maxWidth: `${props.interno}px`, minWidth: `${props.interno}px` }}></div>
            }



        </>
    )
}
